import React from 'react';
import {permissionsAccess} from "../../../helpers/common";
import EditIcon from "../../../assets/icons/edit.svg";
import DepartmentEditModal from "../DepartmentEditModal";
import {HCheckbox} from "../../../validation/HForm";
import {useSelector} from "react-redux";

const DepartmentTabInfo = ({
                               cashBox,
                               showModalDepartmentEdit,
                               error,
                               changeModalState,
                               onCashBoxEdit
                           }) => {
    const {accessFeatures} = useSelector(({user}) => user);
    return (
        <fieldset className="m-t-spacer">
            <div className="content-card">
                <div className="content-card-title">
                    <h3>Подразделение</h3>
                    <div className="content-card-title-actions">
                        {permissionsAccess("action.cashbox.update") &&
                            <button className="button-icontrigger caption noborder"
                                    onClick={() => changeModalState("showModalDepartmentEdit", true)}>
                <span className="icon">
                  <EditIcon/>
                </span>
                                <span>Редактировать</span>
                            </button>
                        }
                        <DepartmentEditModal
                            cashBox={cashBox}
                            onSubmit={onCashBoxEdit}
                            isOpen={showModalDepartmentEdit}
                            onClick={() => changeModalState('showModalDepartmentEdit', false)}
                            error={error}
                            handleBack={() => changeModalState('showModalDepartmentEdit', false)}
                        />
                    </div>
                </div>
                <div className="content-card-content">
                    <div className="form-row">
                        <div className="form-row-item">
                            <div className="form-element">
                                <label className="form-element-label" htmlFor="#">Гор. телефон</label>
                                <div className="form-element-data">
                                    <div className="form-element-data-text">
                                        <p>{cashBox.phone}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            accessFeatures['cashbox.mobile'] &&
                            <div className="form-row-item">
                                <div className="form-element">
                                    <label className="form-element-label" htmlFor="#">Моб. телефон</label>
                                    <div className="form-element-data">
                                        <div className="form-element-data-text">
                                            <p>{cashBox.mobilePhone}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {
                            accessFeatures['cash_box.main.enable'] &&
                            <div className="form-row-item">
                                <div className="form-element">
                                    <label className="form-element-label" htmlFor="#">Дирекция</label>
                                    <div className="form-element-data">
                                        <div className="form-element-data-text">
                                            <HCheckbox
                                                h="true"
                                                name="isMain"
                                                className="input"
                                                id="isMain"
                                                defaultValue={cashBox.isMain}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {
                            accessFeatures['cash_box.auto.enable'] &&
                            <div className="form-row-item">
                                <div className="form-element">
                                    <label className="form-element-label" htmlFor="#">Автоломбард</label>
                                    <div className="form-element-data">
                                        <div className="form-element-data-text">
                                            <HCheckbox
                                                h="true"
                                                name="autoCashBox"
                                                className="input"
                                                id="autoCashBox"
                                                defaultValue={cashBox.autoCashBox}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    <div className="form-row">
                        {cashBox.city &&
                            <div className="form-row-item">
                                <div className="form-element">
                                    <label className="form-element-label" htmlFor="#">Город</label>
                                    <div className="form-element-data">
                                        <div className="form-element-data-text">
                                            <p>{cashBox.city}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        <div className="form-row-item">
                            <div className="form-element">
                                <label className="form-element-label" htmlFor="#">Улица</label>
                                <div className="form-element-data">
                                    <div className="form-element-data-text">
                                        <p>{cashBox.street}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-row-item">
                            <div className="form-element">
                                <label className="form-element-label" htmlFor="#">Дом</label>
                                <div className="form-element-data">
                                    <div className="form-element-data-text">
                                        <p>{cashBox.house}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-row-item">
                            <div className="form-element">
                                <label className="form-element-label" htmlFor="#">Корпус</label>
                                <div className="form-element-data">
                                    <div className="form-element-data-text">
                                        <p>{cashBox.building}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-row-item">
                            <div className="form-element">
                                <label className="form-element-label" htmlFor="#">Офис</label>
                                <div className="form-element-data">
                                    <div className="form-element-data-text">
                                        <p>{cashBox.office}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {cashBox.leader && <div className="form-element">
                        <label className="form-element-label" htmlFor="#">Руководитель</label>
                        <div className="form-element-data">
                            <div className="form-element-data-text">
                                <p>{cashBox.leader.fullName}</p>
                            </div>
                        </div>
                    </div>}
                    {cashBox.chiefAccountant && <div className="form-element">
                        <label className="form-element-label" htmlFor="#">Главный бухгалтер</label>
                        <div className="form-element-data">
                            <div className="form-element-data-text">
                                <p>{cashBox.chiefAccountant.fullName}</p>
                            </div>
                        </div>
                    </div>}
                    {cashBox.accountant && <div className="form-element">
                        <label className="form-element-label" htmlFor="#">Бухгалтер</label>
                        <div className="form-element-data">
                            <div className="form-element-data-text">
                                <p>{cashBox.accountant.fullName}</p>
                            </div>
                        </div>
                    </div>}
                    {cashBox.seniorCommodityExpert && <div className="form-element">
                        <label className="form-element-label" htmlFor="#">Старший товаровед</label>
                        <div className="form-element-data">
                            <div className="form-element-data-text">
                                <p>{cashBox.seniorCommodityExpert.fullName}</p>
                            </div>
                        </div>
                    </div>}
                    {cashBox?.goodsSpecialists && <div className="form-element">
                        <label className="form-element-label" htmlFor="#">Товароведы</label>
                        <div className="form-element-data">
                            <div className="form-element-data-text">
                                <p>{cashBox.goodsSpecialists.map((i) => i?.fullName).join(', ')}</p>
                            </div>
                        </div>
                    </div>}
                    {cashBox.additionalInfo && <div className="form-element">
                        <label className="form-element-label" htmlFor="#">Дополнительная информация</label>
                        <div className="form-element-data">
                            <div className="form-element-data-text">
                                <p>{cashBox.additionalInfo}</p>
                            </div>
                        </div>
                    </div>}
                </div>
            </div>
        </fieldset>
    );
};

export default DepartmentTabInfo;